import React, { useState, useEffect } from "react";
// import { IoNotificationsCircleOutline } from 'react-icons/io5';
import { IoList } from 'react-icons/io5';
import { jwtDecode } from 'jwt-decode';
import { PiUserCircleBold } from "react-icons/pi";

// import { useWindowHeadMutation } from "../../services/post";
// import Loaders from "../../assets/loaders/loaders";


function WindowHead({ sidebarOpen }) {

  const [user, setUser] = useState('-');

  useEffect(() => {
    const token = localStorage.getItem('tokenn')
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded.name);
      } catch (err) {
        console.error('Token decode failed', err);
      }
    }
  }, []);


  return (
    <>
      {/* {isLoading && <Loaders />} */}

      <div className="window_head d-flex justify-content-between align-items-center">
        <span className="d-flex align-items-center ms-2">
          <PiUserCircleBold size={24} />
          <p className="ms-2 mb-0 fw-bold text-capitalize" style={{fontSize: '20px', lineHeight: '15px'}}>{user}</p>
          {/* <p className="me-2 mb-0 fw-bold">PROFILES: {data.totalprofile}</p>
          <p className="mb-0 fw-bold">CONTACTS: {data.uniqueMobile}</p> */}
        </span>

        <span>
          <IoList className="head_btn" id="hamb" onClick={sidebarOpen} />
          {/* <IoNotificationsCircleOutline className="head_btn"/> */}
        </span>
      </div>
    </>
  );
}
export default WindowHead;
